import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { getMagazineById } from '../controllers/magazineController';

const MagazineDetailView = () => {
  const { id } = useParams();
  const [magazine, setMagazine] = useState(null);
  const navigate = useNavigate();
  var magazine_id = null;
  var magazineL = localStorage.getItem('magazine');
  if (magazineL) {
    magazine_id = JSON.parse(magazineL).magazine_id;
  }
  useEffect(() => {
    const params = {
      magazineId: magazine_id
    };
    getMagazineById(params, setMagazine);
  }, [id,magazine_id]);

  if (!magazine) return <p>Loading...</p>;

  return (
    <div className="container mt-4">
      <div className="card">
        <div className="card-body">
          <h5 className="card-title fw-semibold mb-4">Magazine Detail</h5>
          <div className="card">
            <div className="card-body">
              <div className="py-9">
                <div className="d-flex align-items-center mb-9">
                  <div className="ms-6">
                    <h6 className="mb-1">ID: </h6>
                    <p className="mb-0">{magazine.id}</p>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-9">
                  <div className="ms-6">
                    <h6 className="mb-1">Display Name:</h6>
                    <p className="mb-0">{magazine.display_name}</p>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-9">
                  <div className="ms-6">
                    <h6 className="mb-1">Email:</h6>
                    <p className="mb-0">{magazine.email}</p>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-9">
                  <div className="ms-6">
                    <h6 className="mb-1">Google Analytics(GA):</h6>
                    <p className="mb-0">{magazine.ga_code}</p>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-9">
                  <div className="ms-6">
                    <h6 className="mb-1">Magazine Image: </h6>
                    <p className="mb-0"><img src={`${magazine.images}`} width={300} /></p>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-9">
                  <div className="ms-6">
                    <h6 className="mb-1">Introduction: </h6>
                    <p className="mb-0">{magazine.introduction}</p>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-9">
                  <div className="ms-6">
                    <h6 className="mb-1">Website URL: </h6>
                    <p className="mb-0">{magazine.website_url}</p>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-9">
                  <div className="ms-6">
                    <h6 className="mb-1">Magazine Link: <Link className="btn btn-warning btn-sm btn-rounded" target='_blank' to={`https://dittmagasin.no/${magazine.slug}`}>View</Link> <span>You may need subscriber login to access releases</span> </h6>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-9">
                  <div className="ms-6">
                    <h6 className="mb-1">Created At: </h6>
                    <p className="mb-0">{magazine.created_at}</p>
                  </div>
                </div>
              </div>
              <div className="py-4 border-top">
                <button className="btn btn-sm btn-secondary me-2" onClick={() => navigate(-1)}>
                  Back
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MagazineDetailView;
